@if (showsToast) {
  <div class="toast__container">
    <div class="toast__icon">
      <img src="../../../../assets/Images/global-setting/blue-unverified.svg" alt="" />
    </div>
    <div class="toast__text">{{ title }}</div>
    <img (click)="close()" class="toast__cancelIcon" src="../../../assets/Images/roles-responsibilities/cancel.svg" alt="" />
  </div>
}